<style></style>
<template>
  <div>
    <div class="content-box">
      <div
        class="support-index"
        :class="{ 'show-ticket-content': seleccionada }"
      >
        <div class="support-tickets">
          <h5 class="text-center text-dark">Transferencias de stock</h5>
          <div class="text-center">
            <img
              style="width: 110px; height: 100px"
              id="base64image"
              src="data:image/png;base64,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"
            />
          </div>
          <div class="support-tickets-header">
            <div class="tickets-control"></div>
            <div class="tickets-filter">
              <button
                type="button"
                data-toggle="modal"
                data-target="#modalCrearTarea"
                class="btn btn-dark btn-md btn-block"
              >
                Escanear barra <i class="fas fa-search"></i>
              </button>
            </div>
          </div>

          <div>
            <div
              class="modal fade"
              id="modalCrearTarea"
              tabindex="-1"
              role="dialog"
              aria-hidden="true"
            >
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h6 class="modal-title">Scanear barra de reporte</h6>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <div class="col-12">
                      <label v-if="current.scan_barra == true"
                        >Barra de requisición</label
                      >
                      <input
                        focus
                        type="text"
                        class="form-control"
                        v-model="current.barra"
                        ref="barrax"
                      />
                      <small
                        class="text-danger"
                        v-if="errors && errors.barra"
                        >{{ errors.barra[0] }}</small
                      >
                    </div>
                    <br />
                    <div class="col-12">
                      <button
                        @click="obtenerBarra()"
                        type="button"
                        class="btn btn-success btn-md btn-block"
                      >
                        Aceptar
                        <i class="fas fa-check"></i>
                      </button>
                      <br />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="support-ticket-content-w">
          <div class="support-ticket-content">
            <div
              class="support-ticket-content-header mb-0"
              v-if="seleccionada"
              style="display: block"
            >
              <br />
              <a class="back-to-index" href="#" @click="ResetSelect()">
                <i class="os-icon os-icon-arrow-left"></i>
                <span>Atras</span>
              </a>
              <span class="ticket-header" style="font-size: 18px"
                >Información de transferencia stock</span
              >
              <div>
                Estatus:
                <span
                  v-bind:class="{
                    'badge badge-danger': seleccionada.estado == '9',
                    'badge badge-success': seleccionada.estado == 'A',
                    'badge badge-warning ': seleccionada.estado == 'B',
                    'badge badge-dark': seleccionada.estado == 'C',
                  }"
                  >{{ seleccionada.estado_str }}</span
                >
                <br />
                Tienda origen:
                <span class="text-success">{{
                  seleccionada.tienda_origen.nombre
                }}</span>
                <br />
                Tienda destino:
                <span class="text-success">{{
                  seleccionada.tienda_destino.nombre
                }}</span>
                <br />
                Fecha:
                <span class="text-success">{{
                  seleccionada.fecha_creacion | moment("DD/MM/YYYY HH:MM:ss a")
                }}</span>
                <br />
                Observación:
                <span class="text-success">{{ seleccionada.observacion }}</span>
                <br />
                Usuario:
                <span class="text-success">{{
                  seleccionada.usuario.username
                }}</span>
              </div>
              <div>
                <br />
                <div class="element-actions">
                  <div class="btn-group">
                    <button
                      aria-expanded="false"
                      aria-haspopup="true"
                      class="btn btn-secondary dropdown-toggle"
                      data-toggle="dropdown"
                      type="button"
                    >
                      <i class="fa fa-cogs"></i>
                      Acciones
                    </button>
                    <div class="dropdown-menu dropdown-menu-right">
                      <button
                        class="dropdown-item"
                        :class="{ disabled: !(seleccionada.estado == 'B') }"
                        @click="abrir"
                        :disabled="!(seleccionada.estado == 'B')"
                        href="#"
                      >
                        <i class="fa fa-unlock"></i>
                        Abrir Operación
                      </button>
                      <button
                        class="dropdown-item"
                        @click="cerrar"
                        :disabled="!(seleccionada.estado == 'A')"
                        href="#"
                      >
                        <i class="fa fa-lock"></i>
                        Cerrar Operación
                      </button>
                      <button
                        class="dropdown-item"
                        @click="anular"
                        :disabled="!(seleccionada.estado != '9')"
                        href="#"
                      >
                        <i class="fa fa-archive"></i>
                        Anular Operación
                      </button>
                      <button
                        class="dropdown-item"
                        @click="generarTransferenciastock()"
                        :disabled="!(seleccionada.estado != 'A')"
                        href="#"
                      >
                        <i class="fa fa-archive"></i>
                        Generar la transferencia
                      </button>
                      <button
                        :disabled="seleccionada.estado == 'A'"
                        class="dropdown-item"
                        @click="imprimir(seleccionada.id)"
                      >
                        <i class="fa fa-print"></i>
                        Imprimir
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <button
                class="btn btn-md btn-block btn-info"
                @click="verInventarioDeEstacion()"
              >
                Inventario de estación
              </button>
              <br />
              <h6 class="text-success font-weight-bold">Detalle Picking</h6>
              <hr />
              <ModalPickearComponent
                :current="seleccionada"
                @refreshCurrent="refreshData(seleccionada.id)"
              />
            </div>
            <TransferenciaStockDetalleComponent
              :current="seleccionada"
              @refreshCurrent="refreshData(seleccionada.id)"
            />
            <ExistenciasModalComponent
              :seleccionada="seleccionada"
              :existencias="existencias"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import TransferenciaStockDetalleComponent from "@/components/wms/transferencia_stock/TransferenciaStockDetalleComponent";
import ExistenciasModalComponent from "@/components/commons/ExistenciasModalComponent";
import ModalPickearComponent from "@/components/wms/transferencia_stock/ModalPickearComponent";
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";

export default {
  components: {
    TransferenciaStockDetalleComponent,
    ModalPickearComponent,
    TiendaSelectComponent,
    ExistenciasModalComponent,
  },
  data() {
    return {
      existencias: [],
      barra_posicion: "",
      barra: "",
      errors: "",
      seleccionada: null,
      nueva_etiqueta: {
        cantidad: 1,
        errors: {
          cantidad: null,
        },
      },
      current: {
        scan_barra: true,
        id: null,
        estado_str: null,
        tienda: "",
        estado: "",
        errors: [],
      },
    };
  },
  computed: {},
  mounted() {
    let self = this;
    $(".modal").on("shown.bs.modal", function () {
      // $(this).find('[autofocus]').focus();
      self.$refs.barrax.focus();
    });
    if (this.$route.params.id) {
      this.refreshData(this.$route.params.id);
    }
  },
  methods: {
    ResetSelect() {
      this.$router.push({ path: `/wms/transferencia-stock/` });
      this.seleccionada = null;
    },
    abrir() {
      let self = this;
      Notifications.alert.confirm(
        "Transferencia de stock",
        "Desea Abrir la transacción?",
        "Si",
        function () {
          DynamicService.postAction(
            "inv",
            "transferencia_stock",
            self.seleccionada.id,
            "abrir"
          )
            .then((response) => {
              Notifications.alert.success(
                "Transferencia de Stock",
                "Se ha abierto la transaccion."
              );
              self.refreshData(self.seleccionada.id);
            })
            .catch((error) => {
              Notifications.alert.error(
                "abrir Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "Transferencia de Stock",
        "Desea cerrar la transacción?",
        "Si",
        function () {
          DynamicService.postAction(
            "inv",
            "transferencia_stock",
            self.seleccionada.id,
            "cerrar"
          )
            .then((response) => {
              Notifications.alert.success(
                "Transferencia de Stock",
                "Se ha cerrado la transaccion."
              );
              self.refreshData(self.seleccionada.id);
            })
            .catch((error) => {
              Notifications.alert.error(
                "Cerrar Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    anular() {
      let self = this;
      Notifications.alert.confirm(
        "Transferencia de stock",
        "Desea Anular la transacción?",
        "Si",
        function () {
          DynamicService.postAction(
            "inv",
            "transferencia_stock",
            self.seleccionada.id,
            "anular"
          )
            .then((response) => {
              Notifications.alert.success(
                "Transferencia de Stock",
                "Se ha anulado la transaccion."
              );
              self.refreshData(self.seleccionada.id);
            })
            .catch((error) => {
              Notifications.alert.error(
                "anular Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    verInventarioDeEstacion() {
      $("#modalBarraPosicion").modal("show");
    },
    imprimir(det) {
      det = det.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=wms/transferencias_stock/Transferencia_stock.jrxml&id=${det}`
      );
    },
    generarTransferenciastock() {
      let self = this;
      Notifications.alert.confirm(
        "Transferencia de Stock",
        "Desea generar y finalizar la transacción? ya no podra modificar nada.",
        "Si",
        function () {
          DynamicService.postAction(
            "inv",
            "transferencia_stock",
            self.seleccionada.id,
            "generar_transferencia"
          )
            .then((response) => {
              Notifications.alert.success(
                "Transferencia de Stock",
                "Se ha generado la transaccion correctamente."
              );
              self.refreshData(self.seleccionada.id);
            })
            .catch((error) => {
              Notifications.alert.error(
                "Generar transferencia de stock",
                error.response.data.detail
              );
            });
        }
      );
    },
    obtenerBarra() {
      if (this.current.scan_barra == true) {
        if (!this.current.barra) {
          alert("Es necesario el campo de barra");
          return;
        }
        this.current.barra = this.current.barra.replace(/-/g, "");
        this.BuscarTransaccionStock(this.current.barra);
      }
    },
    BuscarTransaccionStock(id) {
      let self = this;
      if (id) {
        DynamicService.fetch("inv", "transferencia_stock", {
          req_traslado_e__id: id,
        })
          .then((response) => {
            if (response.data.results.length == 0) {
              self.buscarRequisicion(id);
            } else {
              self.seleccionar(response.data.results[0].id);
              self.current.barra = "";
            }
          })
          .catch((error) => {
            Notifications.alert.error(
              "Buscar transaccion stock",
              "No se encontro ninguna transaccion con ese dato"
            );
          });
      } else {
        self.refreshData(this.$route.params.id);
      }
    },
    buscarRequisicion(id) {
      let self = this;
      let req_e;
      DynamicService.getById("inv", "req_traslado", id)
        .then((response) => {
          req_e = response.data;
          if (!req_e) {
            Notifications.alert.error(
              "Buscar transaccion stock",
              "No se encontro ninguna transaccion con ese dato"
            );
          } else {
            Notifications.alert.confirm(
              `'Se encontro la requisición' #${req_e.numero}'sin estatus de transferencia stock`,
              "Desea crear la transferencia.",
              "Si",
              function () {
                self.crearTransferenciaStock(id);
                self.current.barra = "";
              }
            );
          }
        })
        .catch((error) => {
          Notifications.alert.error(
            "Buscar requisicion",
            "No se encontro ninguna transaccion con ese dato"
          );
        });
    },
    crearTransferenciaStock(id) {
      let self = this;
      DynamicService.postAction(
        "inv",
        "req_traslado",
        id,
        "generar_transferencia_stock"
      )
        .then((response) => {
          self.BuscarTransaccionStock(id);
        })
        .catch((error) => {
          Notifications.alert.error(
            "Crear transferencia de stock",
            error.response.data.detail
          );
        });
    },
    refreshData(id) {
      let self = this;
      DynamicService.getById("inv", "transferencia_stock", id).then(
        (response) => {
          self.seleccionada = response.data;
          this.current.barra = "";
          $("#modalCrearTarea").modal("hide");
        }
      );
    },
    refreshAll() {
      this.refreshData(this.seleccionada.id);
    },
    seleccionar(id) {
      this.$router.push({ path: `/wms/transferencia-stock/${id}/` });
      this.refreshData(id);
    },
  },
};
</script>
